import { Box, Grid, ToggleButtonGroup, ToggleButton, MenuItem } from '@mui/material';
import { ViewModule as CardsIcon, TableRows as DetailedIcon } from '@mui/icons-material';
import { HorizontalForm, CustomAutoComplete, CustomSelect } from '../../../../common/components';

/**
 * Componente de filtros para el dashboard
 * Permite filtrar y ordenar los proyectos mostrados
 */
const DashboardFilters = ({
  statusFilter,
  projectFilter,
  projects = [],
  sortBy,
  viewMode,
  onStatusFilterChange,
  onProjectFilterChange,
  onSortChange,
  onViewModeChange,
}) => {
  const statusOptions = [
    { value: 'all', label: 'Todos los Estados' },
    { value: 'not_started', label: 'Sin Empezar' },
    { value: 'in_progress', label: 'En Progreso' },
    { value: 'completed', label: 'Completados' },
    { value: 'cancelled', label: 'Cancelados' },
  ];

  const sortOptions = [
    { value: 'name', label: 'Nombre (A-Z)' },
    { value: 'progress', label: 'Mayor Progreso' },
    { value: 'quality', label: 'Mayor Calidad' },
    { value: 'start_date', label: 'Más Recientes' },
  ];

  const projectOptions = (projects || []).map((project) => ({
    value: project.uuid,
    label: project.name || 'Proyecto sin nombre',
  }));

  return (
    <HorizontalForm>
      <Grid container spacing={3} alignItems="center">
        {/* Filtro por Estado */}
        <Grid item xs={12} sm={6} md={3}>
          <CustomSelect
            label="Filtrar por Estado"
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            size="medium"
            fullWidth
          >
            {statusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>

        {/* Filtro por Proyecto */}
        <Grid item xs={12} sm={6} md={3}>
          <CustomAutoComplete
            label="Proyecto"
            name="uuid_project"
            value={projectFilter || ''}
            onChange={(event) => onProjectFilterChange(event.target.value)}
            options={projectOptions}
            optionValueKey="value"
            optionLabelKey="label"
            placeholder="Todos los proyectos"
            size="medium"
            fullWidth
          />
        </Grid>

        {/* Ordenamiento */}
        <Grid item xs={12} sm={6} md={3}>
          <CustomSelect
            label="Ordenar por"
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            size="medium"
            fullWidth
          >
            {sortOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>

        {/* Espaciador - Oculto en móviles para ahorrar espacio */}
        <Grid item xs={12} md={1} sx={{ display: { xs: 'none', md: 'block' } }} />

        {/* Modo de Vista */}
        <Grid item xs={12} sm={6} md={2}>
          <Box display="flex" justifyContent={{ xs: 'center', md: 'flex-end' }}>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  onViewModeChange(newValue);
                }
              }}
              size="small"
            >
              <ToggleButton value="cards" aria-label="vista de tarjetas">
                <CardsIcon />
              </ToggleButton>
              <ToggleButton value="detailed" aria-label="vista detallada">
                <DetailedIcon />
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Grid>
      </Grid>
    </HorizontalForm>
  );
};

export default DashboardFilters;
